export function bindTooltip ($root = $(document)) {
	// console.log('bindTooltip => ', $root)
	var targets = $($root).find('.tooltip-element');
	var tooltip = $('<div id="tooltip" data-tooltip></div>');
	var tooltipRemoved = false;
	// var title = false;

	targets.unbind('click').bind('click', function () {
		show_tooltip($(this));
	});
	targets.unbind('keyup').bind('keyup', function (e) {
		if (!$('body').hasClass('is-mobile') && !$('body').hasClass('is-tablet')) {
			show_tooltip($(this));
			targets.attr('aria-expanded', 'true');
		}
	});
	targets.unbind('mouseover').bind('mouseover', function () {
		if (!$('body').hasClass('is-mobile') && !$('body').hasClass('is-tablet')) {
			show_tooltip($(this));
		}
	});

	var show_tooltip = function (target) {
		var tip = target.attr('title');
		var content = target.attr('data-content');
		tooltip = $('<div id="tooltip" class="tooltipp" aria-describedby="tooltip1" tabindex="0" aria-hidden="false"></div>');

		// if ($('body').hasClass('is-mobile') || $('body').hasClass('is-tablet')) {
			var tooltips = $('body').find('.tooltipp');
			tooltips.each(function() {
				$(this).remove();
			});
		// };
		tooltipRemoved = true;

		if (target.hasClass('active')) {
			return false;
		}
		if (!tip || tip == '') { return false; }

		target.addClass('active');
		target.attr('data-title', target.attr('title'));
		target.removeAttr('title');

		var structure = $('<div class="tooltip__popup"><div class="tooltip-content"></div><div class="tooltip__triangle"></div></div>');

		var headerElem = $('<span class="tooltip-content__title"></span>').text(tip);
		var contentElem = $('<p class="tooltip-content__paragraph"></p>').text(content);

		structure
			.find('.tooltip-content')
			.append(headerElem)
			.append(contentElem);

		tooltip.html('');
		tooltip.css('opacity', 0)
			.append(structure)
			.appendTo('body');

		var init_tooltip = function () {
			if ($(window).width() < tooltip.outerWidth() * 1.5) { tooltip.css('max-width', $(window).width() / 2); } else { tooltip.css('max-width', 300); }
			if(tooltip.outerHeight() > $(window).outerHeight()) {
				tooltip.css({'max-height': '90vh', 'overflow-y': 'scroll'});
			}

			var pos_left = target.offset().left + (target.outerWidth() / 2) - (tooltip.outerWidth() / 2);
			var pos_top = target.offset().top - tooltip.outerHeight() - 20;

			if (pos_left < 0) {
				pos_left = target.offset().left + target.outerWidth() / 2 - 20;
				tooltip.addClass('left');
			} else { tooltip.removeClass('left'); }

			if (pos_left + tooltip.outerWidth() > $(window).width()) {
				pos_left = target.offset().left - tooltip.outerWidth() + target.outerWidth() / 2 + 20;
				tooltip.addClass('right');
			} else { tooltip.removeClass('right'); }

			if (pos_top < 0) {
				var pos_top = target.offset().top + target.outerHeight() + 15;
				tooltip.addClass('top');
			} else { tooltip.removeClass('top'); }

			tooltip.css({ left: pos_left, top: pos_top })
				.animate({ top: '+=10', opacity: 1 }, 50);
		};

		init_tooltip();
		$(window).resize(init_tooltip);

		tooltip.focus();

		target.unbind('mouseleave').bind('mouseleave', function () {
			tooltipRemoved = false;
			remove_tooltip(target, tip);
		});
		tooltip.unbind('click').bind('click', function () {
			tooltipRemoved = false;
			remove_tooltip(target, tip);
		});
		tooltip.blur(function (ev) {
			tooltipRemoved = false;
			remove_tooltip(target, tip);
		});
		tooltip.keyup(function(ev) {
			if(ev.keyCode == 27) {
				target.focus();
			}
		});
	}
	var remove_tooltip = function (target, tip) {
		if (!target.hasClass('active')) {
			return;
		}
		tooltip.animate({ top: '-=10', opacity: 0 }, 50, function () {
			if($(this) && tooltipRemoved == false) {
				$(this).remove();
			}
		});

		target.attr('title', tip);
		target.removeClass('active');
	};
	// $(document).unbind('scroll touchstart').bind('scroll touchstart', function () {
	// 	$('.tooltip-element.active').mouseleave();
	// });
	// $('.popup-b2c__wrapper').unbind('scroll').bind('scroll', function () {
	// 	$('.tooltip-element.active').mouseleave();
	// });

	
}
// $(function () {
// 	bindTooltip();
// });
